// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.78-TSS-3090-mcastro-REMOVING-FULL-ACCESS-Removing-full-access-permission-set-from-guests-entirely.0";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
